// extracted by mini-css-extract-plugin
module.exports = {"HorizonData":"HorizonData_HorizonData__Pu9xO","header":"HorizonData_header__2my6A","panelWrapper":"HorizonData_panelWrapper__23F2x","adWrap":"HorizonData_adWrap__20FBI"};